import { createContext, useContext } from 'react'
import { get } from 'nested-property'

export const PatientContext = createContext()
export const PatientProvider = PatientContext.Provider

/**
 * Get a list of devices from PatientContext
 * @returns {Array} devices
 */
export const useDevices = () => {
  const patient = useContext(PatientContext)
  return get(patient, 'deviceList.devices') || []
}

/**
 * get a list of clients from PatientContext
 * @returns {Array} clients
 */
export const useClients = () => {
  const { clientList } = useContext(PatientContext)

  if (!clientList) {
    throw new Error(
      'Patient is missing `clientList!` This is probably due to using the wrong Patient query.',
    )
  }
  return clientList.clients || []
}

/**
 * Get a device object by device Id, using the PatientContext
 * @param {string} deviceId device id
 * @returns {Object} device
 */
export const useDevice = (deviceId) => {
  const devices = useDevices()
  const device = devices.find((d) => d.id === deviceId)
  return device
}

export default PatientContext
